(() => {
  const configNode = document.getElementById('cf-design-tools-data');
  if (!configNode || window.copyfastDesignToolsLoaded) return;
  window.copyfastDesignToolsLoaded = true;
  const config = JSON.parse(configNode.textContent), copy = config.strings;
  const key = `copyfastSavedDesigns:v1:${config.shopDomain}`;
  const dialogs = {designs:document.getElementById('cf-designs'),comparison:document.getElementById('cf-comparison')};
  let panel, saving = false, revision = 0, lastFocus;
  const status = (element, text, error = false) => {
    if (!element) return;
    element.textContent = text; element.dataset.error = String(error);
  };
  const safePath = value => {
    try {
      const url = new URL(value, location.origin);
      const allowed = [location.hostname,config.shopDomain,new URL(config.shopUrl).hostname];
      if (!['https:','http:'].includes(url.protocol) || !allowed.includes(url.hostname) || !/^\/(?:[a-z]{2}(?:-[a-z]{2})?\/)?products\/[^/]+$/.test(url.pathname) || !url.searchParams.get('customizationId')) return null;
      url.searchParams.delete('isStoredCustomization');
      url.searchParams.delete('cf_designs');
      return url.pathname + url.search;
    } catch (_) { return null; }
  };
  const readLocal = () => {
    try {
      const entries = JSON.parse(localStorage.getItem(key) || '[]');
      return Array.isArray(entries) ? entries.filter(item => item && typeof item.id === 'string' && typeof item.name === 'string' && safePath(item.path)).slice(0,24) : [];
    } catch (_) { return []; }
  };
  let accountEntries = null, csrf = null, syncReady = false;
  const read = () => accountEntries === null ? readLocal() : accountEntries;
  async function accountRequest(body) {
    const response = await fetch('/apps/copyfast-designs/library',{method:body?'POST':'GET',credentials:'same-origin',cache:'no-store',headers:body?{'Content-Type':'application/json'}:{},body:body?JSON.stringify({...body,csrf}):undefined});
    if (!response.ok) { const error = new Error(copy.sync_error); error.status = response.status; throw error; }
    const result = await response.json();
    if (!Array.isArray(result.designs) || typeof result.csrf !== 'string') throw new Error(copy.sync_error);
    return result;
  }
  async function loadAccount() {
    if (!config.accountSyncEnabled) return;
    const message = document.querySelector('[data-cf-account-status]');
    try {
      const result = await accountRequest(); csrf = result.csrf; accountEntries = result.designs; syncReady = true; refreshLibrary();
      status(message,copy.account_ready); document.querySelector('[data-cf-import-local]').hidden = !readLocal().length;
      let auto = false; try { auto = localStorage.getItem(key + ':autoImport') === '1'; } catch (_) {}
      if (auto && readLocal().length) { try { localStorage.removeItem(key + ':autoImport'); } catch (_) {} document.querySelector('[data-cf-import-local]').click(); }
      document.querySelector('[data-cf-account-login]').hidden = true;
    } catch (error) { const guest = error.status === 401 && !config.customerSignedIn; status(message,guest?'':'Your designs are saved in this browser.'); const l = document.querySelector('[data-cf-account-login]'); if (l) l.hidden = true; }
  }
  async function write(entries) {
    
    if (accountEntries !== null) {
      const previous = accountEntries;
      for (const entry of entries) if (!previous.some(old => old.id === entry.id && JSON.stringify(old) === JSON.stringify(entry))) await accountRequest({action:'save',design:entry});
      for (const old of previous) if (!entries.some(entry => entry.id === old.id)) await accountRequest({action:'remove',id:old.id});
      const result = await accountRequest(); accountEntries = result.designs; csrf = result.csrf;
    } else {
      try { localStorage.setItem(key,JSON.stringify(entries)); } catch (_) { throw new Error(copy.storage_error); }
    }
    refreshLibrary();
  }
  document.querySelector('[data-cf-import-local]').addEventListener('click',async event => {
    event.target.disabled = true;
    try {
      for (const entry of readLocal()) await accountRequest({action:'save',design:entry});
      localStorage.removeItem(key); event.target.hidden = true; await loadAccount();
    } catch (_) { status(document.querySelector('[data-cf-account-status]'),copy.sync_error,true); }
    finally { event.target.disabled = false; }
  });
  const portableUrl = path => {
    const url = new URL(path,config.shopUrl);
    if (location.hostname.endsWith('.shopifypreview.com')) url.searchParams.set('preview_theme_id','195741647219');
    return url.href;
  };
  const bookmark = async (name, path, title, image) => {
    const cleaned = safePath(path);
    if (!cleaned) throw new Error(copy.failed);
    const entries = read(), existing = entries.find(item => item.path === cleaned);
    if (!existing && entries.length >= 24) throw new Error(copy.limit);
    const entry = {id:existing?.id || crypto.randomUUID(),name:name.trim().slice(0,80),path:cleaned,title:title || '',image:image || null,updatedAt:Date.now()};
    await write([entry,...entries.filter(item => item.id !== entry.id)]);
    return entry;
  };
  const button = (text, handler) => {
    const element = document.createElement('button'); element.type = 'button'; element.textContent = text; element.addEventListener('click',handler); return element;
  };
  async function copyLink(path, card) {
    const url = portableUrl(path), message = document.querySelector('[data-cf-library-status]');
    try { await navigator.clipboard.writeText(url); status(message,copy.copied); }
    catch (_) {
      card.querySelector('.cf-tools-link-fallback')?.remove();
      const input = document.createElement('input'); input.className = 'cf-tools-link-fallback'; input.readOnly = true; input.value = url; input.setAttribute('aria-label',copy.copy_fallback); card.append(input); input.focus(); input.select(); status(message,copy.copy_fallback);
    }
  }
  function refreshLibrary() {
    const entries = read(), list = document.querySelector('[data-cf-design-list]');
    document.querySelectorAll('[data-cf-saved-count]').forEach(node => { node.textContent = String(entries.length); });
    list.replaceChildren();
    if (!entries.length) {
      const heading = document.createElement('h3'); heading.textContent = copy.empty;
      const help = document.createElement('p'); help.textContent = copy.empty_help;
      list.append(heading,help); return;
    }
    entries.forEach(entry => {
      const card = document.createElement('article'); card.className = 'cf-saved-card';
      if (entry.image && /^https:\/\/(cdn\.shopify\.com|[^/]*\.customily\.com)\//.test(entry.image)) {
        const image = document.createElement('img'); image.src = entry.image; image.alt = entry.title; image.loading = 'lazy'; image.width = 240; image.height = 150; card.append(image);
      }
      const heading = document.createElement('h3'); heading.textContent = entry.name;
      const product = document.createElement('p'); product.textContent = entry.title;
      const actions = document.createElement('div'); actions.className = 'cf-saved-actions';
      const reopen = document.createElement('a'); reopen.href = safePath(entry.path); reopen.className = 'cf-tools-button'; reopen.textContent = copy.reopen;
      actions.append(reopen,button(copy.copy,() => copyLink(entry.path,card)),button(copy.rename,() => {
        if (card.querySelector('[data-cf-rename]')) return;
        const field = document.createElement('input'); field.maxLength = 80; field.value = entry.name; field.dataset.cfRename = ''; field.setAttribute('aria-label',copy.rename);
        const commit = button(copy.rename,async () => {
          if (!field.value.trim()) { status(document.querySelector('[data-cf-library-status]'),copy.name_required,true); field.focus(); return; }
          try { await write(read().map(item => item.id === entry.id ? {...item,name:field.value.trim()} : item)); status(document.querySelector('[data-cf-library-status]'),copy.renamed); }
          catch (error) { status(document.querySelector('[data-cf-library-status]'),error.message,true); }
        });
        card.append(field,commit); field.focus(); field.select();
        field.addEventListener('keydown',event => { if (event.key === 'Enter') { event.preventDefault(); commit.click(); } });
      }),button(copy.remove,async () => {
        try { await write(read().filter(item => item.id !== entry.id)); status(document.querySelector('[data-cf-library-status]'),copy.removed); }
        catch (error) { status(document.querySelector('[data-cf-library-status]'),error.message,true); }
      }));
      card.append(heading,product,actions); list.append(card);
    });
  }
  function openDialog(name, trigger) {
    const dialog = dialogs[name]; if (!dialog) return;
    lastFocus = trigger;
    if (name === 'designs') refreshLibrary();
    dialog.showModal();
  }
  Object.values(dialogs).forEach(dialog => {
    dialog.querySelector('[data-cf-close]').addEventListener('click',() => dialog.close());
    dialog.addEventListener('close',() => lastFocus?.focus());
    dialog.addEventListener('click',event => {
      const rect = dialog.getBoundingClientRect();
      if (event.target === dialog && (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom)) dialog.close();
    });
  });
  document.addEventListener('click',async event => {
    const trigger = event.target.closest('[data-cf-open]');
    if (trigger) { event.preventDefault(); openDialog(trigger.dataset.cfOpen,trigger); }
    const category = event.target.closest('[data-cf-category]');
    if (category) {
      dialogs.comparison.querySelectorAll('[data-cf-category]').forEach(node => node.setAttribute('aria-pressed',String(node === category)));
      dialogs.comparison.querySelectorAll('[data-cf-group]').forEach(node => { node.hidden = category.dataset.cfCategory !== 'all' && node.dataset.cfGroup !== category.dataset.cfCategory; });
      dialogs.comparison.querySelector('[data-cf-guidance]').textContent = config.guidance[category.dataset.cfCategory];
    }
    const cartSave = event.target.closest('[data-cf-cart-save]');
    if (cartSave) {
      try { await bookmark(cartSave.dataset.title,cartSave.dataset.path,cartSave.dataset.title,cartSave.dataset.image); openDialog('designs',cartSave); }
      catch (error) { openDialog('designs',cartSave); status(document.querySelector('[data-cf-library-status]'),error.message,true); }
    }
  });
  const once = (name, trigger, timeout = 30000) => new Promise((resolve,reject) => {
    const handler = event => { clearTimeout(timer); window.removeEventListener(name,handler); resolve(event.detail); };
    const timer = setTimeout(() => { window.removeEventListener(name,handler); reject(new Error(copy.failed)); },timeout);
    window.addEventListener(name,handler);
    try { trigger(); } catch (error) { clearTimeout(timer); window.removeEventListener(name,handler); reject(error); }
  });
  async function saveDesign(event) {
    if (saving) return;
    const share = !!(event && event.currentTarget && event.currentTarget.matches('[data-cf-share]'));
    const name = panel.querySelector('#cf-design-name').value.trim(), message = panel.querySelector('[data-cf-save-status]'), control = panel.querySelector('[data-cf-save]');
    const emailField = share ? null : panel.querySelector('[data-cf-save-email]'), email = emailField ? emailField.value.trim() : (share ? '' : (config.customerEmail || ''));
    if (emailField && !/^[^@\s]+@[^@\s]+\.[^@\s]{2,}$/.test(email)) { status(message,'Enter your email address to save this design.',true); emailField.focus(); return; }
    if (!name) { status(message,copy.name_required,true); panel.querySelector('#cf-design-name').focus(); return; }
    if (!document.querySelector('.customily_sets-container') || !window.engraver?.shareCustomization) { status(message,copy.not_ready,true); return; }
    if (!document.querySelector('.customily_option .customily-file-input-thumbnail img[src]') && ![...document.querySelectorAll('.customily_option input[type=file]')].some(input => input.files?.length)) { status(message,copy.upload_first,true); return; }
    saving = true; control.disabled = true; status(message,copy.saving);
    const startRevision = revision;
    panel.querySelector('[data-cf-save-link]').hidden = true;
    try {
      const response = await once('customily-save-customization-ready',() => window.dispatchEvent(new CustomEvent('customily-save-customization',{detail:{isAddToCart:false}})));
      if (startRevision !== revision) throw new Error(copy.changed);
      const url = new URL(response?.url || '',location.origin);
      const id = document.querySelector('#customily-cart-btn')?.closest('form')?.querySelector('[name=id]')?.value || document.querySelector('form[action*="/cart/add"] [name=id]')?.value;
      if (id) url.searchParams.set('variant',id);
      const entry = await bookmark(name,url.href,config.productTitle,config.productImage);
      const link = panel.querySelector('[data-cf-save-link]'); link.href = entry.path; link.hidden = false;
      status(message,copy.saved);
      if (share) {
        const shareUrl = portableUrl(entry.path), text = 'Here is our design on the ' + config.productTitle + ' from onetaptee. Take a look and tell me if it is good to order:';
        try {
          if (navigator.share && matchMedia('(pointer:coarse)').matches) await navigator.share({title:name,text,url:shareUrl});
          else { await navigator.clipboard.writeText(text + ' ' + shareUrl); status(message,'Link and message copied. Paste it into an email, text or chat to your team.'); }
        } catch (_) { link.textContent = shareUrl; status(message,'Copy this link and send it to your team:'); }
      }
      if (email) {
        status(message,'Saving and emailing your design…');
        let sent = false;
        try { const r = await Promise.race([fetch('https://red-heart-39f6.thomaslafata0.workers.dev/lead',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({email,link:portableUrl(entry.path),name,product:config.productTitle,image:config.productImage})}),new Promise(resolve => setTimeout(resolve,8000))]); sent = !!(r && r.ok); } catch (_) {}
        status(message,sent ? 'Saved. We emailed a link to ' + email + ' so you can reopen this design any time.' : 'Saved in this browser. We could not send the email just now, so use the link below to reopen it.',!sent);
      }
    } catch (error) { status(message,error.message || copy.failed,true); }
    finally { saving = false; control.disabled = false; }
  }
  function mount() {
    const template = document.getElementById('cf-save-panel');
    if (!template || panel?.isConnected) return;
    const editor = document.querySelector('.customily_sets-container');
    const native = document.getElementById('customily-cart-btn');
    if (!editor || !native) return;
    panel = template.content.firstElementChild.cloneNode(true);
    const buttons = document.querySelector('.product-form-buttons') || native.closest('.cl-add-to-cart') || native;
    buttons.before(panel);
    panel.querySelector('[data-cf-save]')?.addEventListener('click',saveDesign);
    panel.querySelector('[data-cf-share]')?.addEventListener('click',saveDesign);
  }
  window.addEventListener('customily-image-uploaded',() => { revision++; if (panel) panel.open = true; });
  window.addEventListener('customily-options-changed',() => { revision++; });
  window.addEventListener('customily-options-loaded',mount);
  window.addEventListener('storage',event => { if (event.key === key) refreshLibrary(); });
  document.addEventListener('change',event => { if (event.target.closest('.customily_option,variant-picker')) revision++; });
  refreshLibrary(); mount(); loadAccount();
  const observer = new MutationObserver(mount);
  if (document.getElementById('cf-save-panel')) observer.observe(document.querySelector('main'),{childList:true,subtree:true});
  if (new URL(location.href).searchParams.get('cf_designs') === '1') openDialog('designs',document.querySelector('[data-cf-open=designs]'));
})();
